/**
 * System-defined price list items for team treasury.
 * Keys map to i18n: priceItem_{key}_title / priceItem_{key}_desc
 */

export interface SystemPriceItemDef {
  key: string;
  icon: string;
  defaultAmount: number;
  category: 'game' | 'season' | 'fun';
}

const systemPriceItems: SystemPriceItemDef[] = [
  { key: 'hatTrick',          icon: 'mdi-hockey-puck',             defaultAmount: 50, category: 'game' },
  { key: 'birthdayOnGameDay', icon: 'mdi-cake-variant-outline',    defaultAmount: 50, category: 'fun' },
  { key: 'firstGoalOfSeason', icon: 'mdi-star-shooting-outline',   defaultAmount: 50, category: 'season' },
  { key: 'shutout',           icon: 'mdi-shield-check-outline',    defaultAmount: 50, category: 'game' },
  { key: 'minorPenalty',       icon: 'mdi-clock-alert-outline',     defaultAmount: 50, category: 'game' },
  { key: 'majorPenalty',       icon: 'mdi-alert-octagon-outline',   defaultAmount: 50, category: 'game' },
  { key: 'shootoutGoal',       icon: 'mdi-bullseye-arrow',          defaultAmount: 50, category: 'game' },
  { key: 'emptyNetGoal',       icon: 'mdi-gate-open',               defaultAmount: 50, category: 'game' },
  { key: 'winningGoal',        icon: 'mdi-trophy-outline',          defaultAmount: 50, category: 'game' },
];

export default systemPriceItems;
